import { cn, filterByAmenity, getSortedPOIs } from "@/lib/utils";
import {
  FilterItemModel,
  // FilterCategoryModel,
} from "@/models/filterItem.model";
import { filterCategories } from "@/store/data";
import useFeaturesStore from "@/store/featuresStore";
import useMapStore from "@/store/mapStore";
import { t } from "i18next";
import Feature from "proximiio-js-library/lib/models/feature";
import React from "react";
// import { FaTimes } from "react-icons/fa";
import Proximiio from "proximiio-js-library";
import {
  osName,
  browserName,
  mobileModel,
  mobileVendor,
  deviceType,
} from "react-device-detect";
import { FaEllipsis } from "react-icons/fa6";

function FiltersToggle() {
  const moreEnabled = false;
  const kioskMode = useMapStore((state) => state.kioskMode);
  const gpsMode = useMapStore((state) => state.gpsMode);
  const map = useMapStore((state) => state.map);
  const activeKiosk = useMapStore((state) => state.activeKiosk);
  const currentLang = useMapStore((state) => state.currentLang);
  const appSession = useMapStore((state) => state.appSession);
  const features = useFeaturesStore((state) => state.features);
  const activeFilter = useMapStore((state) => state.activeFilter);
  const floors = useMapStore((state) => state.floors);
  const currentFloor = useMapStore((state) => state.currentFloor);
  const mobileMode = useMapStore((state) => state.mobileMode);
  const activeCategory = useMapStore((state) => state.activeCategory);
  const setActiveFilter = useMapStore((state) => state.setActiveFilter);
  const setRouteFinish = useMapStore((state) => state.setRouteFinish);
  const setActiveMenuItem = useMapStore((state) => state.setActiveMenuItem);
  const centerToFinish = useMapStore((state) => state.centerToFinish);
  // const setActiveCategory = useMapStore((state) => state.setActiveCategory);

  const pois = getSortedPOIs({ features, currentLang, floors });

  const filterClickHandler = (item: FilterItemModel) => {
    if (item.type === "closest") {
      if (!kioskMode && !gpsMode) {
        item.type = "list";
      }
    }
    const filteredPois = filterByAmenity(pois, item.id);

    if (item.title === activeFilter.title) {
      setActiveFilter({} as FilterItemModel);
      return;
    }

    if (Object.keys(map).length > 0) {
      if ((!gpsMode && !kioskMode) || item.type !== "closest") {
        if (item.type === "single") {
          const feature = features.find((f) => f.id === item.featureId)!;
          setRouteFinish(feature);
          centerToFinish();
        }
        if (filteredPois.length === 1) {
          const feature = features.find((f) => f.id === filteredPois[0].id)!;
          setRouteFinish(feature);
          centerToFinish();
        }
        if (filteredPois.length > 1) {
          const sameLevelFeatures = filteredPois.filter(
            (i) => i.properties.level === currentFloor.level,
          );
          if (sameLevelFeatures.length === 0) {
            const floor = floors.find(
              (f) => f.level === filteredPois[0].properties.level,
            );
            if (floor) {
              map.setFloorById(floor.id);
            }
          }
        }
        setActiveFilter(item);
      } else {
        const closestFeature = map.getClosestFeature(
          item.id as string,
        ) as Feature;
        setActiveFilter(item);
        setRouteFinish(closestFeature);
        centerToFinish();
      }

      if (item.listed !== false) {
        //save amenity select log
        console.log("LOG: save amenity select log");
        const userData = {
          osName,
          browserName,
          mobileModel,
          mobileVendor,
          deviceType:
            kioskMode && !mobileMode && activeKiosk?.name
              ? activeKiosk?.name
              : deviceType,
        };
        new Proximiio.InteractionLogger({
          interactionType: "select",
          targetElementType: "amenity",
          targetElementTitle: item.translatedTitle
            ? item.translatedTitle
            : t(item.title, { lng: "en" }),
          targetElementId: Array.isArray(item.id)
            ? item.id.join("_")
            : item.id
              ? item.id
              : undefined,
          targetElementAmenityCategory: activeCategory
            ? t(activeCategory.title, { lng: "en" })
            : undefined,
          kioskId: activeKiosk?.id ? activeKiosk?.id : undefined,
          kioskTitle: activeKiosk?.name ? activeKiosk?.name : undefined,
          metadata: userData,
          language: currentLang,
          session: appSession,
        });
      }
    }
  };

  /*const closeHandler = () => {
    setActiveMenuItem("map");
    setActiveFilter({} as FilterItemModel);
    setActiveCategory({} as FilterCategoryModel);
    setTimeout(() => {
      if (Object.keys(map).length > 0) {
        map.setFeaturesHighlight([]);
      }
    }, 1000);
  };*/

  const moreHandler = () => {
    setActiveMenuItem("menu");
    setActiveFilter({} as FilterItemModel);
  };

  return (
    <ul className="flex gap-1.5">
      {/*<li className="flex flex-col items-center justify-center">
        <div
          className={cn(
            "flex items-center justify-center rounded-md bg-primary p-3 text-2xl text-white",
          )}
          onClick={closeHandler}
        >
          <FaTimes />
        </div>
        <span className="mt-1 block w-[6ch] truncate text-center text-[11px]">
          {t("cancel")}
        </span>
      </li>*/}

      {filterCategories
        .filter((i) => i.listed !== false)
        .map((category) =>
          category.items
            .filter((i) => i.listed !== false)
            .map((item) => (
              <li
                className="flex flex-col items-center justify-center"
                key={item.title}
                style={{
                  // @ts-expect-error: custom CSS property
                  "--item-color": `hsl(${item.color})`,
                }}
              >
                <div
                  className={cn(
                    "line-clamp-5 flex items-center justify-center rounded-md bg-[var(--item-color)] p-3 text-2xl text-white",
                    category.title === "amenities" && "text-gray-800",
                    !activeFilter?.title || activeFilter?.title === item.title
                      ? "opacity-1"
                      : "bg-gray-400 text-white opacity-50 hover:opacity-80",
                  )}
                  onClick={() => filterClickHandler(item)}
                >
                  {item.icon && React.createElement(item.icon)}
                </div>
                <span className="mt-1 block w-[6ch] truncate text-center text-[11px]">
                  {t(item.title)}
                </span>
              </li>
            )),
        )}

      {moreEnabled && (
        <li className="flex flex-col items-center justify-center">
          <div
            className={cn(
              "flex items-center justify-center rounded-md bg-primary p-3 text-2xl text-white",
            )}
            onClick={moreHandler}
          >
            <FaEllipsis />
          </div>
          <span className="mt-1 block w-[6ch] truncate text-center text-[11px]">
            {t("more")}
          </span>
        </li>
      )}
    </ul>
  );
}

export default FiltersToggle;
